import { createContext } from '@lit/context';
import { APIMenuDefinition, ProductSlug } from '../types';

export type APIMenuSet = Partial<Record<ProductSlug, APIMenuDefinition>>;

/**
 * Products whose menu fetch failed. Separate from `APIMenuSet` so a failure is
 * distinguishable from "not fetched yet" — without it a menu that 403s or times
 * out is indistinguishable from one still in flight, and renders as a permanent
 * "Loading...".
 */
export type APIMenuErrorSet = Partial<Record<ProductSlug, boolean>>;

export const menuDataContext = createContext<APIMenuSet>('menuData');

export const menuErrorContext = createContext<APIMenuErrorSet>('menuErrors');
